<script setup lang="js">
import { ref, onMounted, inject, nextTick } from 'vue';
import { getMoviesMain } from "../assets/api/api";
import { useRouter, useRoute } from "vue-router";
import NavView from "../components/navView.vue";
const router = useRouter();
const route = useRoute();
const channel = ref("");
const YouMightLike = ref([]);
const NewReleases = ref([]);
const TrendingNow = ref([]);
const Popular = ref([]);
const bool = inject("bool");
const home_1_slot = inject("home_1_slot");
const home_2_slot = inject("home_2_slot");
const home_3_slot = inject("home_3_slot");
const home_4_slot = inject("home_4_slot");
const adsClient = inject("adsClient");
const gtagID = inject("gtagID");

const home_1_ins = ref(null);
const home_2_ins = ref(null);
const home_3_ins = ref(null);
const home_4_ins = ref(null);
const dataAdClient = ref(null);
home_1_ins.value = home_1_slot;
home_2_ins.value = home_2_slot;
home_3_ins.value = home_3_slot;
home_4_ins.value = home_4_slot;
dataAdClient.value = 'ca-pub-' + adsClient;
onMounted(() => {
  channel.value = route.params?.channel
  getMoviesMain({
    webFlag: 'novabeats.aipopshort',
  }).then((res) => {
    for (let item in res) {
      res[item].forEach((item) => {
        item.labels = item.labels.split(",");
      });
      YouMightLike.value = res["You Might Like"];
      NewReleases.value = res["NewRelease"];
      TrendingNow.value = res["Trending Now"];
      Popular.value = res["Popular"];
    }
  });
  window.addAds();
})
const goPlay = (info) => {
  if (isGtag) gtag("event", "playVideo", {send_to: gtagID});
  sessionStorage.setItem("playVideoInfo", JSON.stringify(info));
  router.push( channel.value? `/${channel.value}/play/${info.id}/${info.title}/1`:`/play/${info.id}/${info.title}/1`);
};
</script>
<template>
  <NavView />
  <div>
    <!-- Popular on GoodShort -->
    <!-- pc,移动通用顶部广告区域 -->
    <div class="adsItem">
      <div class="adsTopBar text-[12px]">Advertisement</div>
      <ins
        class="adsbygoogle"
        style="display: block"
        :data-ad-client="dataAdClient"
        :data-ad-slot="home_1_ins"
        data-full-width-responsive="true"
      >
      </ins>
      <!-- <ins
        v-else
        class="adsbygoogle"
        style="display: inline-block; width: 750px; height: 90px"
        data-ad-client="ca-pub-7480403109429724"
        data-ad-slot="2261318987"
      >
        <div class="adsTopBar text-[12px]">Advertisement</div>
      </ins> -->
    </div>
    <div class="sixone-content">
      <div class="title">
        <h2>Popular on NovaBeats</h2>
        <!-- <a href="#" class="more">
          <span>More</span>
          <div class="arrow"></div>
        </a> -->
      </div>
      <div class="content">
        <div
          class="row-item"
          v-for="(item, index) in Popular"
          :key="index"
          @click="goPlay(item)"
        >
          <div class="cover">
            <el-image :src="item.coverimage" alt="cover" lazy />
          </div>
          <a class="txt-length-long">
            <h3 class="title two-line-hide">
              {{ item.title }}
            </h3>
          </a>
          <a>
            <div class="type">{{ item.labels[0] }}</div>
          </a>
        </div>
      </div>
    </div>
    <!-- 第一栏目和第二栏目之间广告区域 -->
    <div class="adsItem" v-if="bool">
      <div class="adsTopBar text-[12px]">Advertisement</div>
      <ins
        class="adsbygoogle"
        style="display: block"
        :data-ad-client="dataAdClient"
        :data-ad-slot="home_2_ins"
        data-full-width-responsive="true"
      >
      </ins>
    </div>
    <!-- New Release -->
    <div class="type-column-item-two">
      <div class="type-row">
        <div class="title">
          <h2>New Release</h2>
          <!-- <a href="#" class="more">
            <span>More</span>
            <div class="arrow"></div>
          </a> -->
        </div>
        <div class="content">
          <template v-for="(item, index) in NewReleases" :key="index">
            <div v-if="bool && index == 2" class="adsItem">
              <div class="adsTopBar text-[12px]">Advertisement</div>
              <ins
                class="adsbygoogle"
                style="display: block"
                :data-ad-client="dataAdClient"
                :data-ad-slot="home_3_ins"
                data-full-width-responsive="true"
              >
              </ins>
            </div>
            <div class="new-release-item" @click="goPlay(item)">
              <a class="cover">
                <el-image :src="item.coverimage" alt="cover" lazy />
              </a>
              <div class="row-item-txt">
                <a class="inline-block shrink-0 grow-0">
                  <h3 class="title two-line-hide">
                    {{ item.title }}
                  </h3>
                </a>
                <a>
                  <div class="type one-line-hiden">{{ item.labels[0] }}</div>
                </a>
                <div class="desc-col">
                  {{ item.description }}
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div v-if="!bool" class="adsItem">
      <div class="adsTopBar text-[12px]">Advertisement</div>
      <ins
        class="adsbygoogle"
        style="display: block"
        :data-ad-client="dataAdClient"
        :data-ad-slot="home_3_ins"
        data-full-width-responsive="true"
      >
      </ins>
    </div>
    <!-- Trending Now -->
    <div class="sixone-content">
      <div class="title">
        <h2>Trending Now</h2>
        <!-- <a href="#" class="more">
          <span>More</span>
          <div class="arrow"></div>
        </a> -->
      </div>
      <div class="content">
        <div
          class="row-item"
          v-for="(item, index) in TrendingNow"
          :key="index"
          @click="goPlay(item)"
        >
          <div class="cover">
            <el-image :src="item.coverimage" alt="cover" lazy />
          </div>
          <a class="txt-length-long">
            <h3 class="title two-line-hide">
              {{ item.title }}
            </h3>
          </a>
          <a>
            <div class="type">{{ item.labels[0] }}</div>
          </a>
        </div>
      </div>
    </div>
    <div class="adsItem">
      <div class="adsTopBar text-[12px]">Advertisement</div>
      <ins
        class="adsbygoogle"
        style="display: block"
        :data-ad-client="dataAdClient"
        :data-ad-slot="home_4_ins"
        data-full-width-responsive="true"
      >
      </ins>
    </div>
    <!-- You Might Like -->
    <div class="sixone-content">
      <div class="title">
        <h2>You Might Like</h2>
        <!-- <a href="#" class="more">
          <span>More</span>
          <div class="arrow"></div>
        </a> -->
      </div>
      <div class="content">
        <div
          class="row-item"
          v-for="(item, index) in YouMightLike"
          :key="index"
          @click="goPlay(item)"
        >
          <div class="cover">
            <el-image :src="item.coverimage" alt="cover" lazy />
          </div>
          <a class="txt-length-long">
            <h3 class="title two-line-hide">
              {{ item.title }}
            </h3>
          </a>
          <a>
            <div class="type">{{ item.labels[0] }}</div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
@import url("../assets/css/index.css");
</style>
